import {HeaderNavigation} from "./header-navigation"
import HeroScene from "./hero-scene"
import PromotionsSlider from "./promotions-slider";
import contactMap from "./contact-map";
import SliderContactMap from "./slider-contact-map";
import ContactSendEmail from "./contact-send-email";
import {setFrameLoaded, receivePositionalMessage} from './iframe'
import SubmitNewsletter, {rodoObligation} from "./newsletter";

window.addEventListener('load', () => {
  new HeaderNavigation()
  new HeroScene()
  new PromotionsSlider()
  contactMap()
  new SliderContactMap()
  new ContactSendEmail()
  rodoObligation()
  new SubmitNewsletter()
  setFrameLoaded()
})

window.addEventListener("message",receivePositionalMessage,!1);
